import { Inject, NgModule, Optional, PLATFORM_ID } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { isPlatformServer } from '@angular/common';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express'
import { LangGuardService } from './share/service/lang-guard';


const routes: Routes = [
  { path: '404', loadChildren: () => import('./not-found/not-found.module').then(mod => mod.NotFoundModule) },
  { path: ':lang', loadChildren: () => import('./web-generator/web-generator.module').then(mod => mod.WebGeneratorModule), canActivate: [LangGuardService] },
  { path: '**', loadChildren: () => import('./not-found/not-found.module').then(mod => mod.NotFoundModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(RESPONSE) private response: Response,
    private router: Router
  ) {
    this.router.errorHandler = (error: any) => {
      if (isPlatformServer(this.platformId)) {
        this.response.status(404);
      } else {
        this.router.navigate(['404']); // or redirect to default route
      }
    }
  }
}
